import React, { useEffect } from "react";
import { Alert, Button } from "react-bootstrap";

export const DismissibleAlert = props => {
  if (!props.alert.expired) {
    return (
      <>
        <Alert variant={props.variant}>
          <h6 className="inline">{props.alert.message}</h6>
          <div className="inline justify-content-end">
            <AlertDismissButton onClick={props.onClick} />
          </div>
        </Alert>
      </>
    );
  } else {
    return null;
  }
};

export const AutoDismissibleAlert = props => {
  const newProps = { ...props };
  useEffect(() => {
    var seconds = 5;
    if (seconds > 0) {
      const interval = setInterval(() => {
        if (seconds === 0) {
          newProps.onClick();
          // unmount the component
        } else {
          seconds--;
        }
      }, 1000);
      return () => clearInterval(interval);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!props.alert.expired) {
    return (
      <>
        <Alert variant={props.variant}>
          <h6 className="inline">{props.alert.message}</h6>
          <div>
            <AlertDismissButton onClick={props.onClick} />
          </div>
        </Alert>
      </>
    );
  } else {
    return null;
  }
};

const AlertDismissButton = props => {
  return (
    <Button id="alertDismissButton" className="close" onClick={props.onClick}>
      <span aria-hidden="true">&times;</span>
    </Button>
  );
};

DismissibleAlert.defaultProps = {
  variant: "danger",
  alert: { message: "Default Message" }
};

AutoDismissibleAlert.defaultProps = {
  variant: "info",
  alert: { message: "Default Message" }
};

export default DismissibleAlert;
